<template>
  <div
    class="emd-container emd-card eu-width_100 _highlight_header _header_spaced"
    :style="{ backgroundColor }"
    v-on="$listeners"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EmdCard',
  props: {
    backgroundColor: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.emd-card {
  border-radius: 2px;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgb(0 0 0 / 10%);
}
</style>
